define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.push;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/push.js
// module id = 317
// module chunks = 1